import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {Test} from "common/flowmaster/types/test";
import {LlmRunId} from "common/flowmaster/types/llm_run";

export type WorkflowTestRerunMultipleAction = {
  type: WorkflowsActionTypes["LLM_RUN_TESTS_RERUN_MULTIPLE"]["SUCCESS"];
  payload: {links: Record<string, unknown>; tests: Test[]};
};

export default function rerunWorkflowTests(requestor) {
  return createReduxPromiseAction(
    ActionTypes.LLM_RUN_TESTS_RERUN_MULTIPLE,
    (organisationId: OrganisationId, llmRunIds: LlmRunId) => {
      return requestor
        .post(
          `${basePath}/organisation/${organisationId}/llm_run/test/rerun`,
          {ids: llmRunIds},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
